export const iconFontAwesomeUsersPeopleChildren = (
	<i className="fa-solid fa-children"></i>
);
